.export-records-modal {
  width: 650px;
  margin: 30px 0;
}
